import { render } from "./BtnStar.vue?vue&type=template&id=93bfb28c"
import script from "./BtnStar.vue?vue&type=script&lang=js"
export * from "./BtnStar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__